import { memo } from "react";

function InterviewCardSkeleton() {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between rounded-lg border border-brand-gray-light p-4 bg-white animate-pulse h-auto">
      {/* Left */}
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-4 min-w-0 w-full sm:w-auto">
        {/* Time */}
        <div className="text-sm min-w-27.5 space-y-2 shrink-0">
          <div className="w-24 h-3 bg-gray-200 rounded" />
          <div className="w-16 h-3 bg-gray-200 rounded" />
        </div>

        {/* Info */}
        <div className="space-y-2 min-w-0">
          <div className="w-32 h-4 bg-gray-200 rounded" />
          <div className="w-24 h-3 bg-gray-200 rounded" />
        </div>
      </div>

      {/* Right actions */}
      <div className="flex items-center gap-2 w-full sm:w-auto justify-end sm:justify-start">
        <div className="flex-1 sm:flex-none w-16 h-8 bg-gray-200 rounded-md" />
        <div className="flex-1 sm:flex-none w-20 h-8 bg-gray-200 rounded-md" />
      </div>
    </div>
  );
}

export default memo(InterviewCardSkeleton);
